import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BASE_URL } from 'src/app/models/globals';

export interface Case {
  case_id: string;
  case_title?: string; // Optional title to be added later
  case_content?: string; // HTML content of the case
}

export interface Diagnosis {
  diagnosis_id: string;
  diagnosis_title: string;
  cases: Case[];
}

export interface PracticeCasesResponse {
  success: boolean;
  practiseCasesList: Diagnosis[];
}

@Injectable({
  providedIn: 'root'
})
export class PracticeCasesService {
  private apiUrl = BASE_URL + '/'; // Adjust as needed for your environment

  constructor(private http: HttpClient) { }

  getPracticeCases(): Observable<Diagnosis[]> {
    return this.http.get<PracticeCasesResponse>(this.apiUrl+'getPracticeCases')
      .pipe(
        map(response => {
          if (response.success) {
            // Add case titles (Case1, Case2, etc.) to each case
            return response.practiseCasesList.map(diagnosis => {
              const updatedCases = diagnosis.cases.map((caseItem, index) => {
                return {
                  ...caseItem,
                  case_title: caseItem.case_title
                };
              });
              
              return {
                ...diagnosis,
                cases: updatedCases
              };
            });
          }
          return [];
        })
      );
  }


 
} 